<template>
  <div>
    <van-nav-bar
      title="选择司机"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-search
      v-model="searchvalue"
      placeholder="请输入姓名或手机号搜索"
      @search="onSearch"
    />
    <van-radio-group
      v-model="checked"
      style="height: 100vh; background-color: rgba(228, 228, 228, 1);"
    >
      <van-cell-group  class="chooseoverflow">
        <div v-for="(item,index) in list" :key="item.id">
          <van-cell clickable @click="changeCheck(item.id)">
            <van-row>
              <van-col :span="8">{{ item.name }}</van-col>
              <van-col :span="8">{{ item.mobile }}</van-col>
            </van-row>
            <template #right-icon>
              <van-radio :name="item.id" />
            </template>
          </van-cell>
          <div class="divider" v-if="index!=(list.length-1)"></div>
        </div>
      </van-cell-group>
    </van-radio-group>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import http from "../../api/dashboard";
import {
  NavBar,
  Button,
  Icon,
  Col,
  Row,
  Cell,
  CellGroup,
  Tag,
  Field,
  DatetimePicker,
  Overlay,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Search,
} from "vant";
export default {
  props: ["driverchecked"],
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Overlay.name]: Overlay,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Search.name]: Search,
  },
  setup() {
    const list = ref([]);
    return {
      list,
      checked: "",
      searchvalue: "",
      user:{}
    };
  },
  methods: {
    changeCheck(val) {
      this.checked = val;
      var driverInfo =
        this.list[this.list.findIndex((item) => item.id == val)];
      var name = driverInfo.name;
      this.$emit("closeDriver", val, name);
    },
    getdriverList() {
      var that = this;
      http
        .queryDriverByCompanyId({
          pageNum: "1",
          pageSize: "20",
          companyId:this.user.companyInfo.companyId
        })
        .then((res) => {
          that.list = reactive(res.data.list ? res.data.list : []);
        });
    },
    onSearch() {
      this.getdriverList();
    },
    onClickLeft() {
      this.$emit("closeDriver");
    },
  },
  mounted() {
    this.checked = reactive(this.driverchecked);
    this.$forceUpdate();
    this.user=JSON.parse(localStorage.getItem("user"))
    this.getdriverList();
  },
};
</script>

<style lang="less" scoped="scoped">
.divider {
  border-bottom: 1px solid #CCCCCC;
  padding: 0 20px;
}
.chooseoverflow{
    overflow: auto;
    height: calc(100vh - 110px);
}
</style>